<template>
  <button
    type="button"
    v-if="model && model.vars && model.vars.label"
    :class="'btn btn-' + model.vars.type"
    @click="show"
  >
    <FontAwesomeIcon v-if="model.vars.icon" class="me-2" :icon="'fa-light fa-' + model.vars.icon" />
    {{ model.vars.label }}
  </button>
  <ModalComponent
    :title="model.vars.modal_title ? model.vars.modal_title : model.vars.label"
    :content="model.vars.content"
    :opened="opened"
    :cancelBtn="true"
    @hidden="close"
  />
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ModalComponent from "@/components/ModalComponent.vue";

export default {
  name: "ModalInformationTypeComponent",
  components: { ModalComponent, FontAwesomeIcon },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    show() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  white-space: pre-wrap;
}
</style>
